import { ApiProperty, ApiPropertyOptional } from "@nestjs/swagger";

export class SettingsDto {
    @ApiProperty()
    @ApiPropertyOptional()
    Id:number;
    @ApiProperty()
    @ApiPropertyOptional()
    fbAuthKey:string;
    @ApiProperty()
    @ApiPropertyOptional()
    twitterAuthKey:string;
    @ApiProperty()
    @ApiPropertyOptional()
    instaAuthKey:string;
    @ApiProperty()
    @ApiPropertyOptional()
    termsConditionsUrl :string;
    @ApiProperty()
    @ApiPropertyOptional()
    aboutUsUrl :string;  
    @ApiProperty()
    @ApiPropertyOptional()
    iconUrl :string;
    @ApiProperty({ type: 'array', items: { type: 'string', format: 'binary' } })
    @ApiPropertyOptional()
    iconattachments?: any[];
    @ApiProperty()
    @ApiPropertyOptional()
    iconUploadUrl  :string;
    @ApiProperty()
    @ApiPropertyOptional()
    homeImageUrl:string;
    @ApiProperty({ type: 'array', items: { type: 'string', format: 'binary' } })
    @ApiPropertyOptional()
    spalshattachments?: any[];
    @ApiProperty()
    @ApiPropertyOptional()
    uploadUrl:string;
}